module.exports = __webpack_public_path__ + "img/monster-gray-3.293346f2.png";